var chunkToChildrenMap = {
	"6453": [
		5419,
		9013,
		7925,
		854,
		9923,
		2737
	]
};
__webpack_require__.f.prefetch = function(chunkId, promises) { Promise.all(promises).then(function() {
	var chunks = chunkToChildrenMap[chunkId];
	Array.isArray(chunks) && chunks.map(__webpack_require__.E);
}); };